import React from 'react';
import LanguageToggle from './LanguageToggle';
import { validationDisplayTextEn } from './language/validationDisplayTextEn';
import { validationDisplayTextEs } from './language/validationDisplayTextEs';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { fieldInvalidMsg, fieldErrorMsg, resolveLabel } from './validationMessages';
export const emailPattern = /^(?!.*\.{2})(?!.*?\.\@)(?!.*?\@\.)[a-zA-Z0-9\!#$%&'*+/.=?^_`{|}~-]+@[a-zA-Z0-9\.-]+\.[a-zA-Z0-9]{2,9}$/i;
const usernamePattern = /^[a-zA-Z0-9_+\.-]{1,128}$/;
const legacyUsernamePattern = /^[a-zA-Z0-9_+\.@-]{1,128}$/;
const employeeIdPattern = /^[a-zA-Z0-9]+$/;
const passwordPattern = /^(((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&]))|((?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&])))(?=.{8,})/;
const ssnPattern = /^[0-9]{9}$/;
export const validateAddress1 = (address, label) => {
    if (address && !address.match(/^[0-9A-Za-z .,?#'-]{1,30}$/)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validateAddress2 = (address, label) => {
    if (address && !address.match(/^[0-9A-Za-z .,?#'-]{1,30}$/)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validateCity = (city, label) => {
    if (city && !city.match(/^[ a-zA-Z.'-]{1,30}$/)) {
        return fieldErrorMsg(label, 'cannot exceed 30 characters.', 'no puede exceder 30 caracteres.');
    }
    return undefined;
};
export const validateOtherAddress = (address, label) => {
    if (address && !address.match(/^[0-9 a-zA-Z.,?#'-]{0,255}$/)) {
        return fieldErrorMsg(label, 'cannot exceed 255 characters.', 'no puede exceder 255 caracteres.');
    }
    return undefined;
};
export const validateCharityContact = (charityContact, label) => {
    if (!!charityContact && !charityContact.match(/^[-.',_\/?#@ a-zA-Z0-9]{1,50}$/)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validateCharityName = (charityName, label) => {
    if (!!charityName && !charityName.match(/^[-.',_\/?#@ a-zA-Z0-9]{1,50}$/)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validateGuardianInfo = (info, label) => {
    if (!!info && !info.match(/^[-\s.',_\/?#@ \da-zA-Z]{0,255}$/)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validateTrustName = (trustName, label) => {
    if (!!trustName && !trustName.match(/^[-.',_\/?#@ a-zA-Z0-9]{1,50}$/)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validatePhone = (phoneNumber, label) => {
    if (!phoneNumber) {
        return undefined;
    }
    else if (!phoneNumber.match(/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/) && !phoneNumber.match(/^[0-9]{10}$/)) {
        return fieldErrorMsg(label, 'must be a valid phone number (e.g., 123-456-7890).', 'debe ser un número telefónico válido (ej., 123-456-7890).');
    }
    return undefined;
};
export const validatePhoneNotRequired = (phoneNumber, label) => {
    if (!!phoneNumber && !phoneNumber.match(/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/) && !phoneNumber.match(/^[0-9]{10}$/)) {
        return fieldErrorMsg(label, 'must be a valid phone number (e.g., 123-456-7890).', 'debe ser un número telefónico válido (ej., 123-456-7890).');
    }
    return undefined;
};
export const formatPhone = (phoneNumber) => {
    if (!phoneNumber) {
        return phoneNumber;
    }
    const onlyNums = phoneNumber.replace(/[^\d]/g, '');
    if (onlyNums.length <= 3) {
        return onlyNums;
    }
    if (onlyNums.length <= 7) {
        return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
    }
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
};
export const formatCity = (city) => {
    return city ? city.replace(/[^a-z-.' ]+/gi, '') : undefined;
};
export const formatName = (name) => {
    return name ? name.replace(/[^a-zA-Z-'. ]+/gi, '') : undefined;
};
export const validateName = (name, MAXLENGTH, label, required) => {
    if (name && (name.length > MAXLENGTH || name.match(/[^a-zA-Z-'. ]+/gi))) {
        return fieldErrorMsg(label, `must consist of up to ${MAXLENGTH} alpha [a-zA-Z], punctuation [.\'-], and space characters only.`, `debe tener hasta ${MAXLENGTH} caracteres alfabéticos, puntuación y espacios solamente.`);
    }
    return undefined;
};
export const validateEmail = (email, label) => {
    if (email && (!email.match(emailPattern) || email.length >= 140)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validateOptionalEmail = (email, label) => {
    if (email && (!email.match(emailPattern) || email.length >= 140)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const formatZipCode = (zipCode) => {
    zipCode = zipCode || '';
    return zipCode.replace(/[^\d]/g, '');
};
export const validateZipCode = (zipCode, label) => {
    if (zipCode && zipCode.length !== 5) {
        return fieldErrorMsg(label, 'must be in the format "XXXXX".', 'debe estar en el formato "XXXXX".');
    }
    return undefined;
};
export const validateEmployeeId = (id, label) => {
    if (id && !id.match(employeeIdPattern)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validateUsername = (input, label) => {
    if (!input.match(usernamePattern)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validateLegacyUsername = (input, label) => {
    if (!input.match(legacyUsernamePattern)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const compareEmails = (input, confirmEmailInput, label) => {
    if (confirmEmailInput && input !== confirmEmailInput) {
        return fieldErrorMsg(label, 'does not match.', 'no coincide.');
    }
    return undefined;
};
export const validatePassword = (input, label) => {
    if (!input.match(passwordPattern)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const numbersOnly = (input) => {
    if (input) {
        return input.replace(/[^\d]/g, '');
    }
    return undefined;
};
export const lettersAndNumbersOnly = (input) => {
    if (input) {
        return input.replace(/[^a-z0-9]/gi, '');
    }
    return undefined;
};
export const lettersNumbersAndSpacesOnly = (input) => {
    if (input) {
        return input.replace(/[^a-z0-9 ]/gi, '');
    }
    return undefined;
};
export const formatCurrency = (input) => {
    if (!input) {
        return '';
    }
    const currencyOnlyNumbers = input.replace(/[^0-9.]/g, '');
    if (!currencyOnlyNumbers) {
        return '';
    }
    const last = currencyOnlyNumbers[currencyOnlyNumbers.length - 1];
    const dot = last === '.' ? '.' : '';
    const [dollars, cents = ''] = currencyOnlyNumbers.split('.');
    const formattedCents = cents.slice(0, 2);
    const formattedDollars = parseFloat(dollars || '0').toLocaleString('en-US');
    return formattedCents ? `${formattedDollars}.${formattedCents}` : `${formattedDollars}${dot}`;
};
export const decimalDollar = (input) => {
    if (!input) {
        return '';
    }
    const formattedCurrency = formatCurrency(input);
    const [dollars, cents = ''] = formattedCurrency.split('.');
    const formattedCents = cents.length === 0 ? '00' : cents.length === 1 ? `${cents}0` : cents;
    return `${dollars}.${formattedCents}`;
};
export const validateCurrency = (str, label) => {
    if (str) {
        const regex = /[,\s]/g;
        const result = str.replace(regex, '');
        const amount = parseFloat(result);
        if (amount < 0 || amount > 999999999) {
            return fieldErrorMsg(label, 'must be a valid dollar amount between 0 and 999,999,999.', 'debe ser un monto válido en dólares entre 0 y 999,999,999.');
        }
    }
    return undefined;
};
export const validateCurrencyOptional = (str, label) => {
    if (!str) {
        return undefined;
    }
    const regex = /[,\s]/g;
    const result = str.replace(regex, '');
    const amount = parseFloat(result);
    if (amount < 0 || amount > 999999999) {
        return fieldErrorMsg(label, 'must be a valid dollar amount between 0 and 999,999,999.', 'debe ser un monto válido en dólares entre 0 y 999,999,999.');
    }
    return undefined;
};
export const lettersOnly = (input) => {
    if (!input) {
        return undefined;
    }
    return input.replace(/[^a-zA-Z]/g, '');
};
export const validatePasswordsMatch = (input, input2, label) => {
    if (input !== input2) {
        return fieldErrorMsg(label, 'must match.', 'deben coincidir.');
    }
    return undefined;
};
export const validateBranch = (branchLocation, label) => {
    if (branchLocation) {
        if (!branchLocation.match(/^[0-9]{4}-[0-9]{8}$/)) {
            return fieldInvalidMsg(label);
        }
    }
    return undefined;
};
export const formatBranch = (branchLocation) => {
    if (!branchLocation) {
        return branchLocation;
    }
    const onlyNums = branchLocation.replace(/[^\d]/g, '');
    if (onlyNums.length <= 4) {
        return onlyNums;
    }
    return `${onlyNums.slice(0, 4)}-${onlyNums.slice(4, 12)}`;
};
export const validatePostalCode = (usa, label) => (postalCode) => {
    return usa ? validateUsaPostalCode(postalCode, label) : validateCanadaPostalCode(postalCode, label);
};
function validateUsaPostalCode(postalCode, label) {
    if (postalCode) {
        const usaPostalCodeRegex = /^\d{5}(?:[-]\d{4})?$/;
        return postalCode.match(usaPostalCodeRegex) ? undefined : fieldInvalidMsg(label);
    }
    return undefined;
}
function validateCanadaPostalCode(postalCode, label) {
    if (postalCode) {
        const canadaPostalCodeRegex = /^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/;
        return postalCode.match(canadaPostalCodeRegex) ? undefined : fieldInvalidMsg(label);
    }
}
export const validateSSN = (input, label, errorMessage) => {
    if (input && !ssnPattern.test(input) && !input.match(/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/)) {
        return <LanguageToggle en={validationDisplayTextEn.invalidTaxId} es={validationDisplayTextEs.invalidTaxId}/>;
    }
    return undefined;
};
export const validateSSNFormat = (input, label) => {
    return (input && !ssnPattern.test(input)) ? fieldInvalidMsg(label) : undefined;
};
export const optionalFieldCharacters = (input) => {
    if (!input) {
        return undefined;
    }
    return input.replace(/[^[-\w\s'$.]/g, '');
};
export const validateStreet = (input, label) => {
    if (input && input.match(/[^a-zA-Z0-9\-\s'.,?#]/gi)) {
        return fieldErrorMsg(label, 'must consist of alpha [a-zA-Z], numeric [0-9], punctuation [.,?#\'-], and space characters only.', 'debe tener solo caracteres alfanuméricos, puntuación y espacios.');
    }
    return undefined;
};
export const validateAddressCity = (input, label) => {
    if (input && input.match(/[^a-zA-Z\s.'-]/gi)) {
        return fieldErrorMsg(label, 'must consist of alpha [a-zA-Z], punctuation [.\'-], and space characters only.', 'debe tener solo caracteres alfabéticos, puntuación y espacios.');
    }
    return undefined;
};
export const validateNotes = (input, label) => {
    const pattern = /^[a-zA-Z0-9\-\s\/@!#()_?'.,]+$/;
    if (!input) {
        return undefined;
    }
    if (!input.match(pattern)) {
        return fieldErrorMsg(label, "is invalid. Valid characters are: letters, numbers, spaces, and . , ' - ! ? _ @ # () /", 'no es válido. Caracteres válidos: letras, números, espacios y . , \' - ! ? _ @ # () /');
    }
};
export const formatTitleCase = (input) => {
    if (!input || !input.trim()) {
        return '';
    }
    const words = input.split(' ');
    return words
        .map(word => {
        if (!word) {
            return '';
        }
        const lowerCaseWord = word.toLowerCase();
        return `${lowerCaseWord.charAt(0).toUpperCase()}${lowerCaseWord.slice(1)}`;
    })
        .join(' ');
};
export const formatLowerCase = (input) => {
    if (!input) {
        return '';
    }
    const words = input.split(' ');
    return words
        .map(word => {
        if (!word) {
            return '';
        }
        return word.toLowerCase();
    })
        .join(' ');
};
export const isObjectEmpty = (obj) => {
    if (!obj) {
        return false;
    }
    return Object.entries(obj).filter(([key, value]) => !!value).length === 0;
};
export const phoneNumberValidator = (value, label) => {
    const blacklist = [
        '93',
        '375',
        '243',
        '236',
        '225',
        '86',
        '53',
        '964',
        '98',
        '850',
        '961',
        '231',
        '218',
        '95',
        '234',
        '40',
        '7',
        '252',
        '211',
        '963',
        '380',
        '967',
        '263',
    ];
    if (value) {
        let formattedPhoneNumber = value.replace(/-/g, '').replace(/ /g, '');
        const parsedPhoneNumber = parsePhoneNumberFromString(formattedPhoneNumber, 'US');
        const countryCode = formattedPhoneNumber && formattedPhoneNumber.length > 10 && parsedPhoneNumber
            ? parsedPhoneNumber.countryCallingCode
            : '1';
        let isblacklistedcode = false;
        blacklist.forEach(element => {
            if (element === countryCode) {
                isblacklistedcode = true;
            }
        });
        if (isblacklistedcode) {
            return fieldErrorMsg(label, 'has a non-approved country code for Two Factor Authentication. Please contact technical assistance.', 'tiene un código de país no aprobado para la autenticación de dos factores. Comuníquese con asistencia técnica.');
        }
        if ((parsedPhoneNumber && !parsedPhoneNumber.isValid()) || formattedPhoneNumber.length < 10) {
            return fieldInvalidMsg(label);
        }
    }
    return undefined;
};
export const globalPhoneNumberFormat = (value) => {
    if (!value) {
        return '';
    }
    const numbers = value.replace(/[^\d]/g, '');
    if (numbers.length <= 3) {
        return numbers;
    }
    else if (numbers.length <= 7) {
        return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    }
    else if (numbers.length <= 10) {
        return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
    }
    else if (numbers.length === 11) {
        return `+${numbers.slice(0, 1)} ${numbers.slice(1, 4)}-${numbers.slice(4, 7)}-${numbers.slice(7)}`;
    }
    else if (numbers.length === 12) {
        return `+${numbers.slice(0, 2)} ${numbers.slice(2)}`;
    }
    else if (numbers.length === 13) {
        return `+${numbers.slice(0, 3)} ${numbers.slice(3)}`;
    }
    else {
        return `+${numbers.slice(0, 3)} ${numbers.slice(3, 15)}`;
    }
};
export const validateClaimOrLeaveId = (input) => {
    if (input) {
        return input.replace(/[^\d]/g, '').substring(0, 10);
    }
    return undefined;
};
export const validateAlphaNumeric = (input) => {
    return input ? input.replace(/[^a-z0-9]/gi, '') : undefined;
};
export const formatCurrencyWithCurrencySign = (input, currency) => {
    const parseToString = String(input);
    if (parseToString) {
        const numbersOnly = parseToString.replace(/[^0-9.-]/g, '');
        const givenInput = parseFloat(numbersOnly);
        return !isNaN(givenInput) ? givenInput.toLocaleString('en-US', { style: 'currency', currency }) : undefined;
    }
    return undefined;
};
export const normalizePhone = (value) => {
    if (!value) {
        return value;
    }
    const numbers = value.replace(/[^\d]/g, '');
    if (numbers.length <= 3) {
        return numbers;
    }
    else if (numbers.length <= 7) {
        return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    }
    else if (numbers.length <= 10) {
        return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
    }
    else if (numbers.length === 11) {
        return `+${numbers.slice(0, 1)} ${numbers.slice(1, 4)}-${numbers.slice(4, 7)}-${numbers.slice(7)}`;
    }
    else if (numbers.length === 12) {
        return `+${numbers.slice(0, 2)} ${numbers.slice(2)}`;
    }
    else if (numbers.length === 13) {
        return `+${numbers.slice(0, 3)} ${numbers.slice(3)}`;
    }
    else {
        return `+${numbers.slice(0, 3)} ${numbers.slice(3, 15)}`;
    }
};
export const normalizeSpaces = (value) => {
    if (!value) {
        return value;
    }
    return value.replace(/\s+/g, '');
};
export const preventNonNumericEntry = (e) => {
    if (!/^[0-9 ()+-]+$/.test(e.key) && e.key.toLowerCase() !== 'enter') {
        e.preventDefault();
    }
};
export const validateLastFourSSN = (value, t, label) => {
    const l = resolveLabel(label);
    if (value && value.length !== 4) {
        return t({
            english: `${l.en}: Please enter the last four digits of your SSN`,
            spanish: `${l.es}: Ingrese los últimos cuatro dígitos de su SSN`,
        });
    }
};
/**
 *
 * @deprecated - should be defunct now -- resolve to use built in honest validation
 * left here just in case since this is already translated
 */
export const isFieldRequired = (value, t, label) => {
    const l = resolveLabel(label);
    return !!!value ? t({ english: `${l.en} is required.`, spanish: `${l.es} es obligatorio.` }) : undefined;
};
export const phoneMask = (value) => {
    if (value) {
        var numbers = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        if (numbers) {
            return !numbers[2] ? numbers[1] : '(' + numbers[1] + ') ' + numbers[2] + (numbers[3] ? '-' + numbers[3] : '');
        }
    }
};
